
export default {
    uploadUrl: '/api/brand/file/fileUpload',
    
    token: 'yunduan',

    goodsRefundOrderStatus: { 1: '待商家处理', 2:'寄回商品', 3:'带商户收货', 4:'退款完成', 5:'商家拒绝', 6:'平台介入', 7:'平台拒绝', 8:'用户取消' },   //商品退款订单状态
    wdiv: {
        zIndex: 1001,
        border: '1px solid #ccc'
    },
    toolStyle: {
        zIndex: 1002,
        borderBottom: '1px solid #ccc'
    },
    editorStyle: {
        height: '500px',
        overflowY: 'hidden',
        zIndex: 1001
    }
}